import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AddressFields } from 'addresses/enums';
import { Form } from 'core/components';
import { FormSectionHeader } from 'core/elements';
import { NotificationPosition } from 'core/enums';

import { IUpsertAddressForm } from './types';
import { UpsertAddressFormFields } from './UpsertAddressFormFields';
import { ContactFormFields } from '../ContactFormFields';

interface IProps {
  isOpen: boolean;
  title: string;
  onClose?: (reset?: UseFormReset<IUpsertAddressForm>) => void;
  onSubmit?: (reset: UseFormReset<IUpsertAddressForm>) => (data: IUpsertAddressForm) => void;
  requiredAddressFields?: AddressFields[];
  hasContactFields?: boolean;
  level?: number;
}

export const UpsertAddressForm = ({
  isOpen,
  title,
  onClose,
  onSubmit,
  requiredAddressFields,
  hasContactFields = false,
  level = 0,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Form
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      level={level}
      notificationPosition={NotificationPosition.DRAWER}
    >
      <UpsertAddressFormFields fieldsPrefix="address" requiredFields={requiredAddressFields} />

      {hasContactFields && (
        <>
          <FormSectionHeader title={t('titleContact')} />

          <ContactFormFields />
        </>
      )}
    </Form>
  );
};
